/*
  Behavior port for the Variety Pack (vit2go-nl-variety-pack-landing-page.html):
  gallery nav/thumbs/swipe/keyboard + scroll-reveal. No pack-radio sync
  needed — there is no size selector on this page.
*/
(function () {
  "use strict";

  function initGallery(root) {
    var track = root.querySelector("[data-gal-track]");
    if (!track) { return; }
    var slides = [].slice.call(track.children);
    var thumbs = [].slice.call(root.querySelectorAll("[data-gal-thumb]"));
    var prevBtn = root.querySelector(".gal-nav.prev");
    var nextBtn = root.querySelector(".gal-nav.next");
    var index = 0;

    function render() {
      track.style.transform = "translateX(-" + (index * 100) + "%)";
      thumbs.forEach(function (t, i) {
        t.setAttribute("aria-current", i === index ? "true" : "false");
      });
    }

    function go(i) {
      index = (i + slides.length) % slides.length;
      render();
    }

    if (prevBtn) { prevBtn.addEventListener("click", function () { go(index - 1); }); }
    if (nextBtn) { nextBtn.addEventListener("click", function () { go(index + 1); }); }
    thumbs.forEach(function (t, i) {
      t.addEventListener("click", function () { go(i); });
    });

    var stage = root.querySelector(".gal-stage");
    if (stage) {
      stage.setAttribute("tabindex", "0");
      stage.addEventListener("keydown", function (e) {
        if (e.key === "ArrowLeft") { go(index - 1); }
        if (e.key === "ArrowRight") { go(index + 1); }
      });

      var startX = null;
      stage.addEventListener(
        "touchstart",
        function (e) { startX = e.touches[0].clientX; },
        { passive: true }
      );
      stage.addEventListener(
        "touchend",
        function (e) {
          if (startX === null) { return; }
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) { go(dx < 0 ? index + 1 : index - 1); }
          startX = null;
        },
        { passive: true }
      );
    }

    render();
  }

  function initReveal(root) {
    root.classList.add("js");
    var shopSec = root.querySelector(".shop-sec");
    requestAnimationFrame(function () {
      root.querySelectorAll(".shop-sec .r").forEach(function (el) { el.classList.add("in"); });
    });
    var targets = [].filter.call(root.querySelectorAll(".r"), function (el) {
      return !shopSec || !shopSec.contains(el);
    });
    if (!("IntersectionObserver" in window)) {
      targets.forEach(function (el) { el.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px 200px 0px", threshold: 0 }
    );
    targets.forEach(function (el) { io.observe(el); });
  }

  function initAddToCart(root) {
    var variantInput = root.querySelector('[data-v2g-vp-variant-id]');
    var addBtn = root.querySelector('[data-v2g-vp-add]');
    if (!addBtn || !variantInput) return;

    var qtyValueEl = root.querySelector('[data-v2g-vp-qty-value]');
    var qtyDecBtn = root.querySelector('[data-v2g-vp-qty-decrease]');
    var qtyIncBtn = root.querySelector('[data-v2g-vp-qty-increase]');
    var qty = 1;
    function setQty(n) {
      qty = Math.max(1, n);
      if (qtyValueEl) qtyValueEl.textContent = qty;
    }
    if (qtyDecBtn) qtyDecBtn.addEventListener("click", function () { setQty(qty - 1); });
    if (qtyIncBtn) qtyIncBtn.addEventListener("click", function () { setQty(qty + 1); });

    addBtn.addEventListener("click", function () {
      if (!variantInput.value) return;
      var oldLabel = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = "Toevoegen…";

      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/") + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantInput.value, quantity: qty }] })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/") + "cart.js").then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent("vit2go:cart:updated", { detail: cart }));
          addBtn.textContent = "Toegevoegd aan winkelwagen";
          setQty(1);
        })
        .catch(function () {
          addBtn.textContent = "Er ging iets mis — probeer opnieuw";
        })
        .finally(function () {
          setTimeout(function () { addBtn.textContent = oldLabel; addBtn.disabled = false; }, 1600);
        });
    });
  }

  function init(root) {
    initReveal(root);
    initGallery(root);
    initAddToCart(root);
  }

  function boot() {
    document.querySelectorAll("[data-v2g-variety]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", boot);
  }
})();
